import styles from "./VenuePlannerSkeleton.module.css";

export default function VenuePlannerSkeleton() {
  return (
    <div className={styles.container}>

      {/* Search */}
      <div className={`${styles.skeleton} ${styles.search}`} />

      {/* State & City */}
      <div className={styles.filters}>
        <div className={`${styles.skeleton} ${styles.select}`} />
        <div className={`${styles.skeleton} ${styles.select}`} />
      </div>

      {/* Hotel Cards */}
      <div className={styles.grid}>
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={index} className={styles.card}>

            <div className={`${styles.skeleton} ${styles.image}`} />

            <div className={`${styles.skeleton} ${styles.title}`} />

            <div className={`${styles.skeleton} ${styles.subtitle}`} />

            <div className={`${styles.skeleton} ${styles.button}`} />

          </div>
        ))}
      </div>

    </div>
  );
}